import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import document from './modules/document'
import file from './modules/file'
import location from './modules/location'
import login from './modules/login'
import message from './modules/message'
import param from './modules/param'
import right from './modules/right'
import update from './modules/update'
import work from './modules/work'

Vue.use(Vuex)

const debug = process.env.NODE_ENV != 'production'
const store = new Vuex.Store({
  modules: {
    app,
    document,
    file,
    location,
    login,
    message,
    param,
    right,
    update,
    work
  },
  strict: debug
})
export default store

const initialStateCopy = JSON.parse(JSON.stringify(store.state))

export function resetState() {
  store.replaceState(JSON.parse(JSON.stringify(initialStateCopy)))
}
